// import mapsStyle from './google-maps-styles'

export const apiKey = 'AIzaSyBnIP-I_jUxl6guxKDez8jllOmbdEvFFzQ'

export const defaultZoom = 6
export const center = {
  lat: 46.2192649,
  lng: 2.0517,
}

export const options = {
  mapId: "243fc4169dd35b9d",
  center,
  zoom: defaultZoom,
  // styles: mapsStyle,
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: true,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: true,
}

export const pinSvg =
  '<svg width="29" height="41" enable-background="new 0 0 29 41" viewBox="0 0 29 41" xmlns="http://www.w3.org/2000/svg"><circle cx="14.5" cy="14.7" fill="#fff" r="11.4"/><g fill="currentColor"><path d="m12.3 4.1c6.5-1.5 13.2 3.8 13.1 10.6-.6 14.4-21.2 14.4-21.8 0 0-5.2 3.7-9.6 8.7-10.6m16.7 10.4c0-5.1-2.6-9.5-6.5-12.1-1.1-.7-2.4-1.3-3.6-1.7-2.8-.9-5.8-.9-8.6 0-1.3.4-2.5 1-3.6 1.7-4.3 2.7-7 7.5-6.7 12.8.1 2.6.9 5 2.2 7l11.5 18.4c.2.3.5.5.8.5.4 0 .7-.2.8-.5l11.5-18.4c1.3-2 2.1-4.4 2.2-7 0-.3 0-.5 0-.7"/><path d="m18.5 10.1c.4-.4 1.1-.4 1.5 0s.4 1.1 0 1.5l-5.7 7.1c-.4.4-1.1.5-1.5.1l-3.8-3.8c-.4-.4-.5-1.1-.1-1.5.4-.5 1.1-.5 1.5-.1 0 0 .1 0 .1.1l3 3z"/></g></svg>'


export const regionStyles = {
  strokeColor: "#303a7d",
  strokeOpacity: 1.0,
  strokeWeight: 1.0,
  fillColor: "#810FCB",
  fillOpacity: 0,
};
export const noStyle = {
  strokeColor: "#303a7d",
  strokeOpacity: 0.0,
  strokeWeight: 0.0,
  fillColor: "#810FCB",
  fillOpacity: 0,
};